export const userPreferences = {
  _defaultPreferences: {
    timeFormat: "12h",
    showSeconds: false,
    showAdvancedDivisions: true,
    fontSize: 16,
    displayFormat: "detailed",
    showKalaDivisions: false,
    language: "en"
  },

  init() {
    this._setDefaultPreferences();
    this._loadUserPreferences();

    // suppose there is any update to this store,
    // i dont know how to check if new settings have been added.
    this._watchForChanges();
  },

  _loadUserPreferences() {
    const preferences = JSON.parse(
      localStorage.getItem("preferences") || "null"
    );

    if (preferences) {
      Object.assign(this, preferences);
    } else {
      this._setDefaultPreferences();
      this._saveUserPreferences();
    }
  },

  _saveUserPreferences() {
    const data = Object.fromEntries(this._keys.map((k) => [k, this[k]]));

    localStorage.setItem("preferences", JSON.stringify(data));
  },

  _setDefaultPreferences() {
    Object.assign(this, this._defaultPreferences);
    this._keys = Object.keys(this._defaultPreferences);
  },

  _watchForChanges() {
    Alpine.effect(() => {
      // what should I watch here for ?
      //

      let tmp;
      this._keys.forEach((key) => {
        tmp = this[key];
      });

      this._saveUserPreferences();
    });
  },

  resetToDefaultPreferences(key = null) {
    if (key === null) {
      this._setDefaultPreferences();
      return true;
    } else {
      if (this._defaultPreferences.hasOwnProperty(key)) {
        this[key] = this._defaultPreferences[key];
      } else {
        console.warn("Unknown setting " + key);
      }
    }
  },
};
